import { analyticsAPI } from './services/api';

export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001/api';

// WhatsApp contact number is now fetched from site_settings table (contact_phone field)
// Use the useSettings hook to access it: const { settings } = useSettings();
// Access via: settings.contact_phone

export const trackWhatsAppClick = async (propertyId: string | number) => {
  await analyticsAPI.trackWhatsAppClick(propertyId);
};
